// material-ui
import { createTheme } from '@mui/material/styles';
import { PaletteMode } from '@mui/material';

// assets
import defaultColor from 'assets/scss/_themes-vars.module.scss';
import theme1 from 'assets/scss/_theme1.module.scss';
import theme2 from 'assets/scss/_theme2.module.scss';
import theme3 from 'assets/scss/_theme3.module.scss';
import theme4 from 'assets/scss/_theme4.module.scss';
import theme5 from 'assets/scss/_theme5.module.scss';
import theme6 from 'assets/scss/_theme6.module.scss';

// types
import { ColorProps } from 'types';
import environment from 'environment';

// ==============================|| DEFAULT THEME - PALETTE  ||============================== //

const Palette = (navType: PaletteMode, presetColor: string) => {
    let colors: ColorProps;
    switch (presetColor) {
        case 'theme1':
            colors = theme1;
            break;
        case 'theme2':
            colors = theme2;
            break;
        case 'theme3':
            colors = theme3;
            break;
        case 'theme4':
            colors = theme4;
            break;
        case 'theme5':
            colors = theme5;
            break;
        case 'theme6':
            colors = theme6;
            break;
        case 'default':
        default:
            colors = defaultColor;
    }

    return createTheme({
        palette: {
            mode: navType,
            common: {
                black: '#1E1E1E',
                white: '#FFFFFF'
            },
            primary: {
                light: navType === 'dark' ? '#F4F4F4' : '#F4F4F4',
                main: navType === 'dark' ? '#252525' : environment.THEME_COLORS.BLACK, //'#132239',
                dark: navType === 'dark' ? '#1E1E1E' : '#0B1337',
                200: navType === 'dark' ? 'rgba(114, 112, 255, 0.5)' : 'rgba(114, 112, 255, 0.5)',
                800: navType === 'dark' ? '#5452E1' : environment.THEME_COLORS.PRIMARY
            },
            secondary: {
                200: navType === 'dark' ? 'rgba(244, 244, 244, 0.15)' : 'rgba(19, 34, 57, 0.15)',
                800: navType === 'dark' ? 'rgba(244, 244, 244, 0.5)' : 'rgba(19, 34, 57, 0.5)',
                light: navType === 'dark' ? '#F4F4F4' : '#F4F4F4',
                main: navType === 'dark' ? '#252525' : '#0B1337',
                dark: navType === 'dark' ? '#F4F4F4' : '#132239'
            },
            error: {
                100: 'rgba(205, 4, 64, 0.15)',
                200: 'rgba(255, 0, 0, 0.15)',
                light: 'rgba(255, 77, 73, 0.1)',
                main: environment.THEME_COLORS.SYSTEM_RED,
                dark: '#FF0000'
            },
            orange: {
                light: colors.orangeLight,
                main: colors.orangeMain,
                dark: colors.orangeDark
            },
            warning: {
                light: '#FBCF36',
                main: environment.THEME_COLORS.SYSTEM_YELLOW, //'#FBCF36'
                dark: '#FBCF36'
            },
            success: {
                light: 'rgba(0, 229, 27, 0.1)',
                main: environment.THEME_COLORS.SYSTEM_GREEN,
                dark: environment.THEME_COLORS.SYSTEM_GREEN,
                200: navType === 'dark' ? '#69950f' : '#BEFF38'
            },
            grey: {
                50: colors.grey50,
                100: 'rgba(19, 34, 57, 0.5)',
                200: 'rgba(19, 34, 57, 0.15)',
                500: navType === 'dark' ? colors.darkTextSecondary : colors.grey500,
                600: navType === 'dark' ? colors.darkTextTitle : colors.grey900,
                700: navType === 'dark' ? colors.darkTextPrimary : colors.grey700,
                800: navType === 'dark' ? '#3A3A44' : '#0B1337',
                900: '#132239'
            },
            dark: {
                light: navType === 'dark' ? '#252525' : '#ffffff',
                main: colors.darkLevel1,
                dark: colors.darkLevel2,
                800: colors.darkBackground,
                900: colors.darkPaper
            },
            text: {
                primary: navType === 'dark' ? '#f4f4f4' : '#132239',
                secondary: navType === 'dark' ? '#5452E1' : environment.THEME_COLORS.PRIMARY,
                hint: navType === 'dark' ? 'rgba(244, 244, 244, 0.5)' : 'rgba(19, 34, 57, 0.5)',
                dark: navType === 'dark' ? 'rgba(244, 244, 244, 0.75)' : '#132239'
            },
            divider: navType === 'dark' ? 'rgba(19, 34, 57, 0.15)' : 'rgba(244, 244, 244, 0.15)',
            background: {
                paper: navType === 'dark' ? '#1E1E1E' : environment.THEME_COLORS.BACKGROUND,
                default: navType === 'dark' ? '#1E1E1E' : environment.THEME_COLORS.BACKGROUND
            }
        }
    });
};

export default Palette;
